import { showFixedSideBar, closeFixedSideBar } from "./sb-fixed/index"

export default {
  showFixedSideBar,
  closeFixedSideBar,
}